import { Disclosure, Transition } from '@headlessui/react'
import { ChevronUpIcon } from '@heroicons/react/solid'
import React from 'react'
import Link from '#/components/Link'

interface AsideProps {
  quarter: {
    edges: { node: { id: string; name: string; changelogs: Blog.AllPosts } }[]
  }
}

export default function Aside({ quarter }: AsideProps) {
  return (
    <aside className='sticky top-20 mb-64 ml-6 bg-gray-50'>
      <div className='w-full'>
        <div className='mr-auto rounded-xl shadow'>
          {quarter.edges.map(q => (
            <Disclosure key={q.node.id} defaultOpen>
              {({ open }) => (
                <>
                  <Disclosure.Button className='flex w-full justify-between border-t bg-gray-100 px-6 py-1.5 text-left text-sm font-medium text-gray-500 first:rounded-t-xl first:border-t-0 last:rounded-b-xl focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75'>
                    <span className='my-auto flex items-center'>
                      <span className='text-xs tracking-wide'>
                        {q.node.name}
                      </span>
                    </span>
                    <ChevronUpIcon
                      className={`${
                        open ? 'rotate-180 transform' : ''
                      } h-5 w-5 text-gray-400 text-opacity-60`}
                    />
                  </Disclosure.Button>
                  <Transition
                    enter='transition duration-100 ease-out'
                    enterFrom='transform scale-95 opacity-0'
                    enterTo='transform scale-100 opacity-100'
                    leave='transition duration-75 ease-out'
                    leaveFrom='transform scale-100 opacity-100'
                    leaveTo='transform scale-95 opacity-0'
                  >
                    <Disclosure.Panel className='rounded-b-xl border-t bg-gray-50 bg-opacity-75 px-6 py-4 text-sm text-gray-400'>
                      <ul className='flex flex-col space-y-3'>
                        {q.node.changelogs.edges.map(
                          (log: { node: { title: string; slug: string } }) => (
                            <Link
                              key={log.node.title}
                              href={`/whats-new/${log.node.slug}`}
                            >
                              <li className='cursor-pointer hover:text-primary'>
                                {log.node.title}
                              </li>
                            </Link>
                          )
                        )}
                      </ul>
                    </Disclosure.Panel>
                  </Transition>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
    </aside>
  )
}
